/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { AssessmentMode } from './assessmentMode';
import type { AssessmentDifficulty } from './assessmentDifficulty';
import type { AssessmentRequestFocusTasks } from './assessmentRequestFocusTasks';
import type { AssessmentRequestAdditionalInstructions } from './assessmentRequestAdditionalInstructions';
import type { AssessmentRequestSubmissionId } from './assessmentRequestSubmissionId';

/**
 * Request to generate oral exam questions
 */
export interface AssessmentRequest {
  mode?: AssessmentMode;
  difficulty?: AssessmentDifficulty;
  /** Optional list of task IDs to focus on */
  focusTasks?: AssessmentRequestFocusTasks;
  /** Custom steering prompt for the AI */
  additionalInstructions?: AssessmentRequestAdditionalInstructions;
  /**
   * @minimum 1
   * @maximum 50
   */
  questionCount?: number;
  /** Optional student submission ID for personalized questions */
  submissionId?: AssessmentRequestSubmissionId;
}
